function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function e(e) {
  return e.replace(/(?:[_-])([a-z0-9])/g, function (e, t) {
    return t.toUpperCase();
  });
}

function t(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}

function r(e, t) {
  var r = s(e);
  return Array.from(r.reduce(function (e, r) {
    return function (e, t) {
      var r = e[t];
      return Array.isArray(r) ? r : [];
    }(r, t).forEach(function (t) {
      return e.add(t);
    }), e;
  }, new Set()));
}

function n(e, t) {
  return s(e).reduce(function (e, r) {
    return e.push.apply(e, _toConsumableArray(function (e, t) {
      var r = e[t];
      return r ? Object.keys(r).map(function (e) {
        return [e, r[e]];
      }) : [];
    }(r, t))), e;
  }, []);
}

function s(e) {
  var t = [];

  for (; e;) {
    t.push(e), e = Object.getPrototypeOf(e);
  }

  return t.reverse();
}

function a(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      t = _ref2[0],
      r = _ref2[1];

  return function (t, r) {
    var n = "".concat((a = t, a.replace(/([A-Z])/g, function (e, t) {
      return "-".concat(t.toLowerCase());
    })), "-value"),
        s = function (e) {
      var t = function (e) {
        var t = o(e.type);

        if (t) {
          var _r = i(e.default);

          if (t !== _r) throw new Error("Type \"".concat(t, "\" must match the type of the default value. Given default value: \"").concat(e.default, "\" as \"").concat(_r, "\""));
          return t;
        }
      }(e),
          r = i(e),
          n = o(e),
          s = t || r || n;

      if (s) return s;
      throw new Error("Unknown value type \"".concat(e, "\""));
    }(r);

    var a;
    return {
      type: s,
      key: n,
      name: e(n),

      get defaultValue() {
        return function (e) {
          var t = o(e);
          if (t) return c[t];
          var r = e.default;
          return void 0 !== r ? r : e;
        }(r);
      },

      get hasCustomDefaultValue() {
        return void 0 !== i(r);
      },

      reader: u[s],
      writer: l[s] || l.default
    };
  }(t, r);
}

function o(e) {
  switch (e) {
    case Array:
      return "array";

    case Boolean:
      return "boolean";

    case Number:
      return "number";

    case Object:
      return "object";

    case String:
      return "string";
  }
}

function i(e) {
  switch (_typeof(e)) {
    case "boolean":
      return "boolean";

    case "number":
      return "number";

    case "string":
      return "string";
  }

  return Array.isArray(e) ? "array" : "[object Object]" === Object.prototype.toString.call(e) ? "object" : void 0;
}

(function () {
  function e(e) {
    function t() {
      return Reflect.construct(e, arguments, this instanceof t ? this.constructor : void 0);
    }

    return t.prototype = Object.create(e.prototype, {
      constructor: {
        value: t
      }
    }), Reflect.setPrototypeOf(t, e), t;
  }

  try {
    (function () {
      var t = e(function () {
        this.a.call(this);
      });
      t.prototype.a = function () {}, new t();
    })();
  } catch (t) {
    return function (e) {
      return /*#__PURE__*/function (_e2) {
        _inherits(_class, _e2);

        var _super = _createSuper(_class);

        function _class() {
          _classCallCheck(this, _class);

          return _super.apply(this, arguments);
        }

        return _class;
      }(e);
    };
  }
})();

var c = {
  get array() {
    return [];
  },

  boolean: !1,
  number: 0,

  get object() {
    return {};
  },

  string: ""
},
    u = {
  array: function array(e) {
    var t = JSON.parse(e);
    if (!Array.isArray(t)) throw new TypeError("Expected array");
    return t;
  },
  boolean: function boolean(e) {
    return !("0" == e || "false" == e);
  },
  number: function number(e) {
    return Number(e);
  },
  object: function object(e) {
    var t = JSON.parse(e);
    if (null === t || "object" != _typeof(t) || Array.isArray(t)) throw new TypeError("Expected object");
    return t;
  },
  string: function string(e) {
    return e;
  }
},
    l = {
  default: function _default(e) {
    return "".concat(e);
  },
  array: h,
  object: h
};

function h(e) {
  return JSON.stringify(e);
}

var f = /*#__PURE__*/function () {
  function f(e) {
    _classCallCheck(this, f);

    this.context = e;
  }

  _createClass(f, [{
    key: "application",
    get: function get() {
      return this.context.application;
    }
  }, {
    key: "scope",
    get: function get() {
      return this.context.scope;
    }
  }, {
    key: "element",
    get: function get() {
      return this.scope.element;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.scope.identifier;
    }
  }, {
    key: "targets",
    get: function get() {
      return this.scope.targets;
    }
  }, {
    key: "classes",
    get: function get() {
      return this.scope.classes;
    }
  }, {
    key: "data",
    get: function get() {
      return this.scope.data;
    }
  }, {
    key: "initialize",
    value: function initialize() {}
  }, {
    key: "connect",
    value: function connect() {}
  }, {
    key: "disconnect",
    value: function disconnect() {}
  }, {
    key: "dispatch",
    value: function dispatch(e) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$target = _ref3.target,
          t = _ref3$target === void 0 ? this.element : _ref3$target,
          _ref3$detail = _ref3.detail,
          r = _ref3$detail === void 0 ? {} : _ref3$detail,
          _ref3$prefix = _ref3.prefix,
          n = _ref3$prefix === void 0 ? this.identifier : _ref3$prefix,
          _ref3$bubbles = _ref3.bubbles,
          s = _ref3$bubbles === void 0 ? !0 : _ref3$bubbles,
          _ref3$cancelable = _ref3.cancelable,
          a = _ref3$cancelable === void 0 ? !0 : _ref3$cancelable;

      var o = new CustomEvent(n ? "".concat(n, ":").concat(e) : e, {
        detail: r,
        bubbles: s,
        cancelable: a
      });
      return t.dispatchEvent(o), o;
    }
  }], [{
    key: "shouldLoad",
    get: function get() {
      return !0;
    }
  }]);

  return f;
}();

f.blessings = [function (e) {
  return r(e, "classes").reduce(function (e, r) {
    var _Object$assign;

    return Object.assign(e, (_Object$assign = {}, _defineProperty(_Object$assign, "".concat(n = r, "Class"), {
      get: function get() {
        var e = this.classes;
        if (e.has(n)) return e.get(n);
        {
          var _t = e.getAttributeName(n);

          throw new Error("Missing attribute \"".concat(_t, "\""));
        }
      }
    }), _defineProperty(_Object$assign, "".concat(n, "Classes"), {
      get: function get() {
        return this.classes.getAll(n);
      }
    }), _defineProperty(_Object$assign, "has".concat(t(n), "Class"), {
      get: function get() {
        return this.classes.has(n);
      }
    }), _Object$assign));
    var n;
  }, {});
}, function (e) {
  return r(e, "targets").reduce(function (e, r) {
    var _Object$assign2;

    return Object.assign(e, (_Object$assign2 = {}, _defineProperty(_Object$assign2, "".concat(n = r, "Target"), {
      get: function get() {
        var e = this.targets.find(n);
        if (e) return e;
        throw new Error("Missing target element \"".concat(n, "\" for \"").concat(this.identifier, "\" controller"));
      }
    }), _defineProperty(_Object$assign2, "".concat(n, "Targets"), {
      get: function get() {
        return this.targets.findAll(n);
      }
    }), _defineProperty(_Object$assign2, "has".concat(t(n), "Target"), {
      get: function get() {
        return this.targets.has(n);
      }
    }), _Object$assign2));
    var n;
  }, {});
}, function (e) {
  var r = n(e, "values"),
      s = {
    valueDescriptorMap: {
      get: function get() {
        var _this = this;

        return r.reduce(function (e, t) {
          var r = a(t),
              n = _this.data.getAttributeNameForKey(r.key);

          return Object.assign(e, _defineProperty({}, n, r));
        }, {});
      }
    }
  };
  return r.reduce(function (e, r) {
    return Object.assign(e, function (e) {
      var _ref4;

      var r = a(e),
          n = r.key,
          s = r.name,
          o = r.reader,
          i = r.writer;
      return _ref4 = {}, _defineProperty(_ref4, s, {
        get: function get() {
          var e = this.data.get(n);
          return null !== e ? o(e) : r.defaultValue;
        },
        set: function set(e) {
          void 0 === e ? this.data.delete(n) : this.data.set(n, i(e));
        }
      }), _defineProperty(_ref4, "has".concat(t(s)), {
        get: function get() {
          return this.data.has(n) || r.hasCustomDefaultValue;
        }
      }), _ref4;
    }(r));
  }, s);
}], f.targets = [], f.values = {};

var d = /*#__PURE__*/function (_f) {
  _inherits(d, _f);

  var _super2 = _createSuper(d);

  function d() {
    _classCallCheck(this, d);

    return _super2.apply(this, arguments);
  }

  _createClass(d, [{
    key: "connect",
    value: function connect() {
      this.hasUrlValue ? this.hasLazyLoadingValue ? this.lazyLoad() : this.load() : console.error("[stimulus-content-loader] You need to pass an url to fetch the remote content.");
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.stopRefreshing();
    }
  }, {
    key: "load",
    value: function load() {
      this.fetch(), this.hasRefreshIntervalValue && this.startRefreshing();
    }
  }, {
    key: "lazyLoad",
    value: function lazyLoad() {
      var _this2 = this;

      var e = {
        threshold: this.lazyLoadingThresholdValue,
        rootMargin: this.lazyLoadingRootMarginValue
      };
      new IntersectionObserver(function (e, t) {
        e.forEach(function (e) {
          e.isIntersecting && (_this2.load(), t.unobserve(e.target));
        });
      }, e).observe(this.element);
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function () {
      var _this3 = this;

      fetch(this.urlValue).then(function (e) {
        return e.text();
      }).then(function (e) {
        _this3.element.innerHTML = e, _this3.loadScriptsValue && _this3.loadScripts();
      });
    })
  }, {
    key: "startRefreshing",
    value: function startRefreshing() {
      var _this4 = this;

      this.refreshTimer = setInterval(function () {
        _this4.fetch();
      }, this.refreshIntervalValue);
    }
  }, {
    key: "stopRefreshing",
    value: function stopRefreshing() {
      this.refreshTimer && clearInterval(this.refreshTimer);
    }
  }, {
    key: "loadScripts",
    value: function loadScripts() {
      this.element.querySelectorAll("script").forEach(function (e) {
        var t = document.createElement("script");
        t.innerHTML = e.innerHTML, document.head.appendChild(t).parentNode.removeChild(t);
      });
    }
  }]);

  return d;
}(f);

d.values = {
  url: String,
  lazyLoading: Boolean,
  lazyLoadingThreshold: Number,
  lazyLoadingRootMargin: {
    type: String,
    default: "0px"
  },
  refreshInterval: Number,
  loadScripts: Boolean
};
export default d;